'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTENT_NOTICES = _constantsAnalytics2.default.CATEGORIES.CONTENT_NOTICES;
var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS,
    ADD_CONTENT_NOTICE = _analyticsConstants$E.ADD_CONTENT_NOTICE,
    EDIT_CONTENT_NOTICE = _analyticsConstants$E.EDIT_CONTENT_NOTICE,
    REMOVE_CONTENT_NOTICE = _analyticsConstants$E.REMOVE_CONTENT_NOTICE;
var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS,
    ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
    EDIT_ITEM = _analyticsConstants$A.EDIT_ITEM,
    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT;


function composeContentAdvisoriesEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: CONTENT_NOTICES,
    gtmAction: action
  });
}

function composeAddContentAdvisoriesEvent() {
  return (0, _compose.composeAnalytics)([composeContentAdvisoriesEvent(ADD_CONTENT_NOTICE, ADD_CONTENT)]);
}

function composeEditContentAdvisoriesEvent() {
  return (0, _compose.composeAnalytics)([composeContentAdvisoriesEvent(EDIT_CONTENT_NOTICE, EDIT_ITEM)]);
}

function composeRemoveContentAdvisoriesEvent() {
  return (0, _compose.composeAnalytics)([composeContentAdvisoriesEvent(REMOVE_CONTENT_NOTICE, REMOVE_CONTENT)]);
}

exports.default = {
  composeAddContentAdvisoriesEvent: composeAddContentAdvisoriesEvent,
  composeEditContentAdvisoriesEvent: composeEditContentAdvisoriesEvent,
  composeRemoveContentAdvisoriesEvent: composeRemoveContentAdvisoriesEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/contentAdvisoriesEventComposer.js
// module id = 579
// module chunks = 0 2 4 5 6 8 9 10 11